import { render } from "./searchby-doc.vue?vue&type=template&id=1ccb7716&scoped=true"
import script from "./searchby-doc.vue?vue&type=script&lang=js"
export * from "./searchby-doc.vue?vue&type=script&lang=js"

import "./searchby-doc.vue?vue&type=style&index=0&id=1ccb7716&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccb7716"]])

export default __exports__